var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.656,
    height: 18,
    viewBox: "0 0 21.656 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 21.656,
    height: 18,
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Columns_icon",
    "data-name": "Columns icon",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M18.42,0H3.236A3.238,3.238,0,0,0,0,3.235V14.765A3.238,3.238,0,0,0,3.236,18H18.42a3.238,3.238,0,0,0,3.236-3.235V3.235A3.238,3.238,0,0,0,18.42,0M11.6,1.552h3.929v14.9H11.6Zm-1.553,14.9H6.122V1.552h3.929Zm-8.5-1.682V3.235A1.684,1.684,0,0,1,3.236,1.552H4.569v14.9H3.236a1.684,1.684,0,0,1-1.682-1.682m18.549,0a1.684,1.684,0,0,1-1.682,1.682H17.087V1.552H18.42A1.684,1.684,0,0,1,20.1,3.235Z",
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsicon);
export default __webpack_public_path__ + "static/media/Columnsicon.72ec4815ba6ef3e002e444eaa1b37c59.svg";
export { ForwardRef as ReactComponent };